import './toggle-modal';

$('.summernote').summernote({
    height: 300,
  });
